import DANROCK_LOGO from "@/lib/danrockLogo";
import { resolveAssetUrl } from "@/lib/api";

// ---------------------------------------------------------------------------
// Letterhead definitions. To change the text printed on the DanRock letterhead
// (CIN, phone, address ...), edit the DANROCK block below and rebuild.
// ---------------------------------------------------------------------------
const GOLD = "#C49A22";

const DANROCK = {
  key: "danrock",
  logo: DANROCK_LOGO,
  companyName: "Corebricks Construction Pvt. Ltd.",
  brandName: "Danrock Builders", // shown on receipts
  divisionLine: "(A Division of Corebricks Construction Pvt. Ltd.)",
  tagline: "(Operating as Danrock Builders)",
  cin: "CIN: U45200AS2025PTC000000",
  addressLines: ["Zoo Road, Opposite Doordarshan Kendra,", "Guwahati – 781024, Assam, India"],
  phone: "+91 60007 89906",
  email: "corebrikz@gmail.com",
  website: "",
  accent: GOLD,
  signatureCompany: "For Corebricks Construction Pvt. Ltd.",
};

// Any other business falls back to a letterhead built from its profile (logo, name, address, phone, email).
export function getLetterhead(profile) {
  const name = profile?.name || "";
  if (/danrock|corebrick/i.test(name)) return DANROCK;
  return {
    key: "generic",
    logo: profile?.logo_url ? resolveAssetUrl(profile.logo_url) : "",
    companyName: name,
    brandName: name,
    divisionLine: "",
    tagline: "",
    cin: profile?.gst_number ? `GSTIN: ${profile.gst_number}` : "",
    addressLines: (profile?.address || "").split("\n").map((s) => s.trim()).filter(Boolean),
    phone: profile?.phone || "",
    email: profile?.email || "",
    website: "",
    accent: GOLD,
    signatureCompany: name ? `For ${name}` : "",
  };
}
